import { Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';

export const CreditSafePortfolioSchema = WithBaseEntitySchema(
    z.object({
        portfolioId: z.string(),
        name: z.string(),
    }),
).strict();

export class CreditSafePortfolio extends FromSchema(CreditSafePortfolioSchema) implements BaseEntity {
    id: string;
    portfolioId: string;
    name: string;

    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    createdBy?: Executor;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
